export enum ViewInputModeEnum {
  Mouse = 'mouse',
  Touch = 'touch'
}
